import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Zoom from "react-reveal/Zoom";

import logo from "./img/AODG26844.png";

// החלף אחר כך לתמונות שלך
import bg1 from "./img/3.jpeg";
import bg2 from "./img/landing-page2.jpeg";
import bg3 from "./img/2.jpeg";

const images = [bg1, bg2, bg3];

const HeroContainer = styled.section`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
`;

const Slide = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${props => props.bg});
  background-size: cover;
  background-position: center;
  opacity: ${props => (props.active ? 1 : 0)};
  transition: opacity 1.5s ease-in-out;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    rgba(0, 0, 0, 0.55),
    rgba(0, 0, 0, 0.65)
  );
`;

const Content = styled.div`
  position: relative;
  z-index: 10;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;
  padding: 20px;
`;

const Logo = styled.img`
  width: 120px;
  max-width: 80vw;

  animation: float 4s ease-in-out infinite;

  @keyframes float {
    0% {
      transform: translateY(0px);
    }

    50% {
      transform: translateY(-10px);
    }

    100% {
      transform: translateY(0px);
    }


  }


  }
`;

const Title = styled.h1`
  color: white;
  font-size: clamp(2.2rem, 6vw, 5rem);
  font-weight: 800;
  margin: 20px 0 10px;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.95);
  font-size: clamp(1rem, 2vw, 1.4rem);
  max-width: 700px;
  margin-bottom: 30px;
  line-height: 1.7;
`;

const Buttons = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
`;

const MainButton = styled.a`
  text-decoration: none;
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
  color: white;
  padding: 14px 30px;
  border-radius: 50px;
  font-weight: 700;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }
`;

const WhatsAppButton = styled.a`
  text-decoration: none;
  background: #25d366;
  color: white;
  padding: 14px 30px;
  border-radius: 50px;
  font-weight: 700;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }
`;

const Dots = styled.div`
  position: absolute;
  bottom: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
  z-index: 20;
`;

const Dot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props =>
    props.active ? "#fff" : "rgba(255,255,255,0.4)"};
`;

function Head() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(slider);
  }, []);

  return (
    <HeroContainer>
      {images.map((image, index) => (
        <Slide
          key={index}
          bg={image}
          active={index === current}
        />
      ))}

      <Overlay />

      <Content>
        <Zoom>
          <Logo
            src={logo}
            alt="S.G One ניקיון ואחזקות"
          />
        </Zoom>

        <Title>
          S.G One
          <br />
          ניקיון ואחזקות
        </Title>

        <Subtitle>
          שירותי ניקיון ואחזקת מבנים ברמה הגבוהה ביותר,
         אמינות, מקצועיות ושירות
        </Subtitle>

      </Content>

      <Dots>
        {images.map((_, index) => (
          <Dot
            key={index}
            active={index === current}
          />
        ))}
      </Dots>
    </HeroContainer>
  );
}

export default Head;